<template>
  <div class="vff-animate q-form f-fade-in-up">
    <div class="q-inner">
      <div>
        <div :class="{ fh2: true }">
          <div class="f-answer f-full-width">
            <div class="row mt-5 mb-1">
              <div class="col-12">
                <div v-if="answer" v-dompurify-html="answer" class="kb-answer"></div>
                <div class="kb-disclaimer" v-dompurify-html="disclaimer.value"></div>
              </div>
              <div class="col-12 row-gap-5">
                <div class="vff-animate f-fade-in f-enter">
                  <Popper
                    :content="$t('kb.back_to_questions')"
                    hover
                    arrow
                    class="fs-5 align-self-center"
                    placement="bottom"
                    theme="light"
                  >
                    <button
                      ref="button"
                      class="o-btn-action"
                      type="button"
                      href="#"
                      @click.prevent="goToQuestions()"
                    >
                      <AppIcon icon="change" />
                    </button>
                  </Popper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType, ComputedRef } from 'vue'
import { router } from '@inertiajs/vue3'
import { KbQAData, KbLocalization } from '~types/concierge'
import { useIdentityStore } from '~conciergeUiCommons/store/identityStore'
import { wTrans } from 'laravel-vue-i18n'

export default defineComponent({
  name: 'KbAnswer',
  props: {
    question: {
      type: Object as PropType<KbQAData>,
      required: true
    },
    answer: {
      type: String as PropType<string>,
      default: ''
    },
    lang: {
      type: String as PropType<keyof KbLocalization>,
      required: true
    }
  },
  setup() {
    const identityStore = useIdentityStore()
    return {
      identityStore
    }
  },
  computed: {
    disclaimer(): ComputedRef<string> {
      return wTrans('kb.disclaimer', {
        dealership: this.identityStore.identity?.contact?.organization ?? ''
      })
    }
  },
  methods: {
    goToQuestions(): void {
      if (this.question?.endpoints?.questions && this.question.endpoints.questions[this.lang]) {
        return router.visit(this.question.endpoints.questions[this.lang] as string)
      }
    }
  }
})
</script>

<style scoped lang="scss">
.kb-disclaimer {
  font-size: var(--font-size-smallest);
  font-weight: 300;
  color: var(--dealer-primary-color);
  margin: 2em 0;
}
</style>
